import React from 'react';

import { useLastNameInitialExperiment } from '#src/app/pages/petitionDetails/shared/hooks';

import { RecentSignersFeedImpression } from './components/RecentSignersFeedImpression';
import { RecentSignersFeedItem } from './components/RecentSignersFeedItem';
import { useRecentSignersConnection } from './hooks/useRecentSignersConnection';
import { useScrollableFeed } from './hooks/useScrollableFeed';
import { MIN_SIGNERS_TO_SHOW } from './shared/constants';

const DEFAULT_INTERVAL_SECONDS = 3;

export const RecentSignersFeed: React.FC = () => {
	const baseRecentSigners = useRecentSignersConnection();
	const scrollerRef = useScrollableFeed(DEFAULT_INTERVAL_SECONDS, baseRecentSigners.length);
	const { showAbbreviated } = useLastNameInitialExperiment();

	if (baseRecentSigners.length < MIN_SIGNERS_TO_SHOW) {
		return null;
	}

	// Doubling the recent signers to create a seamless scrolling effect.
	const recentSigners = [...baseRecentSigners, ...baseRecentSigners];

	return (
		<div className="relative mb-7">
			{/* Outside the gapped scroller below — Waypoint's in-flow span would eat a gap unit there. */}
			<RecentSignersFeedImpression signerCount={baseRecentSigners.length} />
			<div
				ref={scrollerRef}
				className="flex snap-x snap-proximity flex-row gap-3 overflow-x-hidden scroll-smooth whitespace-nowrap"
			>
				{recentSigners.map((signer, index) => (
					<RecentSignersFeedItem key={`${signer.id}-${index}`} item={signer} showAbbreviated={showAbbreviated} />
				))}
			</div>
			<div
				aria-hidden
				className="pointer-events-none absolute top-0 right-0 h-full w-full bg-[linear-gradient(to_right,transparent_80%,var(--color-fill-inverse-strong))]"
			/>
		</div>
	);
};
